<style>

.code{
  display: grid;
  grid-template-columns: 40px 40px 40px 40px 40px 40px;
  /* width: 180px; */
  text-align: center;
  justify-content: space-evenly;
  color: white;
}
.code1{ grid-column: 1; }
.code2{ grid-column: 2; }
.code3{ grid-column: 3; }
.code4{ grid-column: 4; }
.code5{ grid-column: 5; }
.code6{ grid-column: 6; }
.outline{
  border: 1px white solid;
  height: 43px;
  font-size: 35px;
  text-align: center;
  margin: 1px;
}
</style>

<div class="code">
  <div class="code1 outline">{code1}</div>
  <div class="code2 outline">{code2}</div>
  <div class="code3 outline">{code3}</div>
  <div class="code4 outline">{code4}</div>
  <div class="code5 outline">{code5}</div>
  <div class="code6 outline">{code6}</div>
</div>

<script>

export let textCode = "000000";

let code1, code2, code3, code4, code5, code6;

$:{
  if (textCode) {
    if (textCode.length == 6) {
      code1 = textCode[0];
      code2 = textCode[1];
      code3 = textCode[2];
      code4 = textCode[3];
      code5 = textCode[4];
      code6 = textCode[5];
    }
  }
}
</script>